export const friendlyErrorMessage = (message) => {
  const fallback = "Proses belum berhasil. Periksa kembali data yang diisi.";
  const text = String(message || "").trim();
  if (!text) return fallback;

  const lower = text.toLowerCase();
  const technicalPatterns = [
    "sql",
    "database",
    "constraint",
    "duplicate key",
    "violates",
    "uuid",
    "invalid input syntax",
    "foreign key",
    "null value",
    "syntax error",
    "pq:",
    "driver:",
    "panic",
    "stack",
    "internal server error",
    "err_db",
    "unauthorized -",
    "failed hmac",
    "invalid audience",
    "invalid issuer",
  ];

  if (technicalPatterns.some((pattern) => lower.includes(pattern))) {
    if (lower.includes("duplicate") || lower.includes("unique")) {
      return "Data tersebut sudah tersedia.";
    }
    if (lower.includes("foreign key") || lower.includes("masih digunakan")) {
      return "Data belum dapat diproses karena masih terkait dengan data lain.";
    }
    if (lower.includes("unauthorized") || lower.includes("token")) {
      return "Sesi login berakhir. Silakan login kembali.";
    }
    return fallback;
  }

  return text;
};
